import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-despesa-planejamentos-edit',
  templateUrl: './despesa-planejamentos-edit.component.html',
  styleUrls: ['./despesa-planejamentos-edit.component.css']
})
export class DespesaPlanejamentosEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
